<template>
<v-card class="silver-price-widget" :style="cardStyle" outlined>
  <!-- Provider -->
  <div class="silver-price-provider">
    {{ name }}
  </div>

  <!-- Loading -->
  <div v-if="loading" class="silver-price-loading">
    <v-progress-circular indeterminate size="24" width="2" color="white" />
  </div>

  <!-- Error -->
  <div v-else-if="error" class="silver-price-error">
    <v-icon small color="white" class="ml-1">
      mdi-alert-circle-outline
    </v-icon>

    <span>{{ error }}</span>
  </div>

  <!-- Prices -->
  <div v-else class="silver-price-content">
    <div class="silver-price-item">
      <div class="silver-price-purity">
        (995)
      </div>

      <div class="silver-price-value">
        {{ formatPrice(prices["995"]) }}
      </div>
    </div>

    <div class="silver-price-divider"></div>

    <div class="silver-price-item">
      <div class="silver-price-purity">
        (999.9)
      </div>

      <div class="silver-price-value">
        {{ formatPrice(prices["999.9"]) }}
      </div>
    </div>


  </div>
  <div v-if="sourceUpdatedTime" class="silver-price-updated">
    <span class="silver-price-time">
    {{ sourceUpdatedTime.time }}
    </span>

    <span class="silver-price-date">
    {{ sourceUpdatedTime.date }}
    </span>
  </div>
</v-card>
</template>

<script>
export default {
  name: "SilverPriceWidget",

  props: {
    name: {
      type: String,
      required: true,
    },

    prices: {
      type: Object,
      default: () => ({
        "995": null,
        "999.9": null,
      }),
    },

    loading: {
      type: Boolean,
      default: false,
    },

    error: {
      type: String,
      default: null,
    },

    minPrice: {
      type: Number,
      default: null,
    },

    maxPrice: {
      type: Number,
      default: null,
    },

    sourceUpdatedAt: {
      type: [String, Date],
      default: null,
    },
  },

  computed: {
    cardStyle() {
      const price = Number(
        this.prices && this.prices["995"]
      )

      if (
        !Number.isFinite(price) ||
        !Number.isFinite(this.minPrice) ||
        !Number.isFinite(this.maxPrice)
      ) {
        return {
          backgroundColor: "#78909C",
        }
      }

      const colors = [
        // pink
        // "#F06292", // lighten-3
        // "#EC407A", // lighten-2
        // "#D81B60", // lighten-1
        // "#C2185B", // darken-1
        // "#AD1457", // darken-2
        // "#880E4F", // darken-3
        // deep-purple
        // "#9575CD", // lighten-3
        // "#7E57C2", // lighten-2
        // "#5E35B1", // lighten-1
        // "#512DA8", // darken-1
        // "#4527A0", // darken-2
        // "#311B92", // darken-3
        // blue-grey
        "#90A4AE", // lighten-3
        "#78909C", // lighten-2
        "#546E7A", // lighten-1
        "#455A64", // darken-1
        "#37474F", // darken-2
        "#263238", // darken-3
      ]

      if (this.maxPrice === this.minPrice) {
        return {
          backgroundColor: colors[2],
        }
      }

      const ratio = Math.max(
        0,
        Math.min(
          1,
          (price - this.minPrice) /
          (this.maxPrice - this.minPrice)
        )
      )

      const index = Math.round(
        ratio * (colors.length - 1)
      )

      return {
        backgroundColor: colors[index],
      }
    },

    sourceUpdatedTime() {
      if (!this.sourceUpdatedAt) {
        return null
      }

      const date = new Date(this.sourceUpdatedAt)

      if (Number.isNaN(date.getTime())) {
        return null
      }

      return {
        date: date.toLocaleDateString('fa-IR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }),

        time: date.toLocaleTimeString('fa-IR', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }),
      }
    },

  },

  methods: {

    formatPrice(value) {
      const number = Number(value)

      if (!Number.isFinite(number)) {
        return "-"
      }

      return number.toLocaleString("fa-IR")
    },
  },
}
</script>

<style scoped>
.silver-price-widget {
  width: 100%;
  min-width: 240px;
  min-height: 112px;

  border: none !important;
  border-radius: 12px !important;
  overflow: hidden;

  color: #ffffff;

  box-shadow:
    0 3px 10px rgba(0, 0, 0, 0.14) !important;

  transition:
    background-color 0.4s ease,
    box-shadow 0.2s ease;
}

/* --------------------------------
   Provider
-------------------------------- */

.silver-price-provider {
  text-align: center;

  font-size: 20px;
  font-weight: 800;

  padding: 9px 8px 4px;

  color: rgba(255, 255, 255, 0.96);
}

/* --------------------------------
   Prices
-------------------------------- */

.silver-price-content {
  display: flex;
  align-items: center;

  padding: 4px 5px 12px;
}

.silver-price-item {
  flex: 1;
  min-width: 0;

  text-align: center;
}

.silver-price-purity {
  font-size: 16px;
  line-height: 1.2;
  font-weight: 600;

  color: rgba(255, 255, 255, 0.68);

  margin-bottom: 2px;
}

.silver-price-value {
  font-size: 25px;
  line-height: 1.25;
  font-weight: 800;

  color: #ffffff;

  white-space: nowrap;

  letter-spacing: -0.5px;
}

.silver-price-divider {
  width: 1px;
  height: 38px;

  flex-shrink: 0;

  background: rgba(255, 255, 255, 0.22);
}

/* --------------------------------
   Loading
-------------------------------- */

.silver-price-loading {
  height: 73px;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* --------------------------------
   Error
-------------------------------- */

.silver-price-error {
  min-height: 73px;

  padding: 10px 12px;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;

  font-size: 12px;
  line-height: 1.6;

  color: rgba(255, 255, 255, 0.95);
}

.silver-price-updated {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  gap: 12px;

  direction: ltr;

  padding: 0 8px 8px;

  font-size: 16px;
  font-weight: 900;
  line-height: 1.4;

  color: rgba(255, 255, 255, 0.62);
}

.silver-price-date,
.silver-price-time {
  white-space: nowrap;
}
</style>
